import React from "react";
import { useTranslation } from "react-i18next";


export default function BigModal({ open, onClose, title, children }) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
      <div className="
        bg-white dark:bg-neutral-900
        w-full max-w-3xl
        rounded-lg shadow-xl
        max-h-[90vh]
        flex flex-col
      ">
        
        {/* HEADER */}
        <div className="p-4 border-b flex items-center justify-between">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="px-2 py-1 text-sm hover:bg-gray-200 dark:hover:bg-neutral-800 rounded"
          >
            {t("close")}
          </button>
        </div>

        {/* BODY — skrol */}
        <div className="p-4 overflow-y-auto flex-1">
          {children}
        </div>
      </div>
    </div>
  );
}
